import React from 'react';
import PropTypes from 'prop-types';
import I18n from 'i18n-js';
import ModelSelect from './index';

const LibrarySelect = ({ ...props }) => (
  <ModelSelect
    {...props}
    selectType="library"
    title={`${I18n.t('library')}:`}
  />
);

LibrarySelect.propTypes = {
  initialOption: PropTypes.shape({
    label: PropTypes.string,
    value: PropTypes.string,
  }).isRequired,
  options: PropTypes.arrayOf(PropTypes.shape({
    label: PropTypes.string,
    value: PropTypes.string,
  })).isRequired,
  programId: PropTypes.number.isRequired,
  resourceUrl: PropTypes.string.isRequired,
};

export default LibrarySelect;
